var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { observable, computed } from 'mobx';
import { parse, stringify } from './queryString';

var Location = (_class = function () {
	_createClass(Location, [{
		key: 'query',
		get: function get() {
			return parse(this._search.slice(1));
		},
		set: function set(query) {
			var queryString = stringify(query);
			this.search = queryString && '?' + queryString;
			return true;
		}
	}, {
		key: 'search',
		get: function get() {
			return this._search;
		},
		set: function set(search) {
			this._wrapper.push({ search: search });
			return true;
		}
	}, {
		key: 'hash',
		get: function get() {
			return this._hash;
		},
		set: function set(hash) {
			this._wrapper.push({ hash: hash });
			return true;
		}
	}, {
		key: 'pathname',
		get: function get() {
			return this._pathname;
		},
		set: function set(pathname) {
			this._wrapper.push({ pathname: pathname });
			return true;
		}
	}]);

	function Location(wrapper, loc) {
		_classCallCheck(this, Location);

		_initDefineProp(this, '_search', _descriptor, this);

		_initDefineProp(this, '_hash', _descriptor2, this);

		_initDefineProp(this, '_pathname', _descriptor3, this);

		_initDefineProp(this, 'state', _descriptor4, this);

		this._wrapper = wrapper;
		this._search = loc.search;
		this._pathname = loc.pathname;
		this._hash = loc.hash;
		this._state = loc.state;
	}

	return Location;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '_search', [observable], {
	enumerable: true,
	initializer: function initializer() {
		return '';
	}
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, '_hash', [observable], {
	enumerable: true,
	initializer: function initializer() {
		return '';
	}
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, '_pathname', [observable], {
	enumerable: true,
	initializer: function initializer() {
		return '';
	}
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'state', [observable], {
	enumerable: true,
	initializer: function initializer() {
		return {};
	}
}), _applyDecoratedDescriptor(_class.prototype, 'query', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'query'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'search', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'search'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hash', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'hash'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'pathname', [computed], Object.getOwnPropertyDescriptor(_class.prototype, 'pathname'), _class.prototype)), _class);
export { Location as default };